import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { TmAccountDetails } from "../TmAccountDetails";
import { Box } from "@mui/material";
import { useLogout } from "../../hooks/useLogout";
import { useTeamConfig } from "../TeamConfigProvider";

export const useAuthLoginErrorModal = createState({
  isOpen: false,
  errorMessage: "",
  disableLogout: false,
  tmAccountDetails: {
    email: "",
    accountId: "",
  },
});

export function AuthLoginErrorModal() {
  const router = useRouterExt();
  const modalState = useAuthLoginErrorModal();
  const { handleLogout } = useLogout();
  const { TEAM_GLOBAL_SETTINGS } = useTeamConfig();

  const onClose = async () => {
    modalState.reset();
    if (!modalState?.disableLogout) {
      if (!TEAM_GLOBAL_SETTINGS?.IS_BALLPARK_APP) return await handleLogout();
      router.pushSchema(routes.landing);
    }
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Error"
      description={
        <>
          {modalState?.tmAccountDetails?.email ? (
            <Box py={1}>
              <TmAccountDetails
                email={modalState.tmAccountDetails.email}
                accountId={modalState.tmAccountDetails.accountId}
              />
            </Box>
          ) : null}
          <Box
            py={1}
            dangerouslySetInnerHTML={{ __html: modalState.errorMessage }}
          />
        </>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Close",
          onClick: async () => await onClose(),
        },
        secondaryButton: {
          isHidden: true,
        },
      }}
    />
  );
}
